import { Message, Box, Text } from '@workwhile/ui'
import { FiAlertOctagon } from 'react-icons/fi'
import styled from 'styled-components'

const StyledIcon = styled(FiAlertOctagon)`
  vertical-align: middle;
  margin-top: 2px;
  color: #a86a00;
`

export const OrientationWarningMessage = () => (
  <Box mb={4}>
    <Message
      variant="warning"
      icon={<StyledIcon />}
      fontSize={2}
      style={{
        border: '1px solid #ffad28',
        borderRadius: 4,
        padding: '20px 24px',
      }}
    >
      <Text as="span" fontWeight="bold">
        This assignment includes a special orientation shift.
      </Text>{' '}
      If you replace this worker, the replacement will be scheduled without
      having completed the required orientation.
      <br />
      <br />
      If you need your replacement to attend orientation, please select "Do Not
      Replace" and then create a new Long Term Assignment with an orientation
      shift.
    </Message>
  </Box>
)
